import { ReactNode } from 'react'

import { ArrowUpRight } from './CitationPill'
import { KW } from './theme'

interface Props {
  children: ReactNode
  onClick?: () => void
}

/** Teal text action ("Open in list view ↗") — hand-off to a classic screen. */
const HandoffLink = ({ children, onClick }: Props) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex cursor-pointer items-center gap-[3px] border-0 bg-transparent p-0 text-xs font-bold"
    style={{ color: KW.teal500, fontFamily: 'inherit' }}
  >
    {children}
    <ArrowUpRight size={12} />
  </button>
)

export default HandoffLink
